import type { FC } from "react"

import UsageStartDateTab from "./UsageStartDateTab"
import styles from "./UsageStartDateTab.module.scss"

import { useSouhlAdminQuery } from "@/provider/apollo/Apollo"
import { graphql } from "@/souhl_admin/gql/__generated__"

const getCompanyForUsageStartDateQuery = graphql(/* GraphQL */ `
	query getCompanyForUsageStartDate($param: CompanyParam!) {
		company(param: $param) {
			currentCompany: company {
				salons {
					...UsageStartDateTab
				}
			}
		}
	}
`)

type Props = {
	companyId: string
}

const UsageStartDateTabContainer: FC<Props> = ({ companyId }) => {
	const { data, loading, refetch } = useSouhlAdminQuery(
		getCompanyForUsageStartDateQuery,
		{
			variables: { param: { id: companyId } },
			fetchPolicy: "no-cache",
		}
	)

	if (loading) {
		return <div className={styles.card}>読み込み中...</div>
	}

	const fragments = data?.company?.currentCompany?.salons ?? []
	if (fragments.length === 0) {
		return <div className={styles.card}>店舗がありません。</div>
	}

	return (
		<UsageStartDateTab
			companyId={companyId}
			fragment={fragments}
			onUpdated={refetch}
		/>
	)
}

export default UsageStartDateTabContainer
